<template>
  <form
    @submit.prevent="submitForm"
    class="row"
  >
    <div class="col-xs-8">
      <div class="row">
        <section class="col-xs-12">
          <Box>
            <BaseInput
              label="ID / navn"
              v-model="info.name"
            />

            <BaseFormField label="Publiceringsdato">
              <Datejump v-model="info.publishDate">
                <BaseDatetimePicker v-model="info.publishDate" />
              </Datejump>
            </BaseFormField>

            <BaseFormField label="Status">
              <BaseCheckbox
                label="Slettet"
                v-model="info.deleted"
              />
            </BaseFormField>

            <BaseCheckbox
              label="Udsend notifikation"
              v-model="info.sendNotification"
            />

            <BaseTextarea
              label="Intern note"
              v-model="info.internalNote"
            />

            <BaseFormField label="Varenumre">
              <BaseSelect
                v-model="productNumbers"
                placeholder="Tilføj varenumre"
                label="productNumber"
                class="default"
                track-by="productNumber"
                tag-position="bottom"
                :options="[]"
                :multiple="true"
                :taggable="true"
                @tag="addProductNumber"
              />
            </BaseFormField>
          </Box>

          <Box>
            <RouteOfAdministrationPicker :list="routeOfAdministrations" />
          </Box>

          <Box>
            <h3>Indholdsstoffer</h3>
            <BaseSelect
              v-model="selectedSubstances"
              placeholder="Søg efter indholdsstoffer"
              label="name"
              class="default"
              track-by="id"
              tag-position="bottom"
              :options="activeSubstancesList"
              :multiple="true"
              :taggable="false"
              @select="onToggleSelectSubstance"
            />
          </Box>

          <Box>
            <GlobalNotesSelector
              :notes="filteredGlobalNotes"
              :current-date="this.info.publishDate"
              @input="onToggleNote"
            />
          </Box>

          <Box>
            <LocalNotes
              :notes="filteredLocalNotes"
              @add="localNotes.push($event)"
              @remove="onRemoveLocalNote"
            />
          </Box>
        </section>
        <div class="col-xs-12">
          <BaseButton
            label="Gem præparat"
            :disabled="loading"
            full
          />
          <BaseSpinner
            height="40px"
            width="40px"
            v-if="loading"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import BaseDatetimePicker from '../../BaseDatetimePicker.vue';
import Datejump from '../../Datejump.vue';
import BaseSelect from '../../BaseSelect.vue';
import RouteOfAdministrationPicker from '../../RouteOfAdministrationPicker.vue';
import LocalNotes from '../../LocalNotes.vue';
import GlobalNotesSelector from '../../GlobalNotesSelector.vue';
import BaseCheckbox from '../../BaseCheckbox.vue';
import Box from '../../Box.vue';
import BaseSpinner from '../../BaseSpinner.vue';
import BaseButton from '../../BaseButton.vue';
import BaseTextarea from '../../BaseTextarea.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseInput from '../../BaseInput.vue';
import PreparationService from '../../../services/PreparationService';
import CreateUpdatePreparation from '../../../mixins/CreateUpdatePreparation';

export default {
    name: 'CreatePreparationForm',
    mixins: [CreateUpdatePreparation],
    components: {
        BaseInput,
        BaseFormField,
        BaseTextarea,
        BaseButton,
        BaseSpinner,
        Box,
        BaseCheckbox,
        GlobalNotesSelector,
        LocalNotes,
        RouteOfAdministrationPicker,
        BaseSelect,
        Datejump,
        BaseDatetimePicker,
    },
    props: {
        defaultItem: { type: Object, default: () => {} },
    },
    methods: {
        async submitForm() {
            if (!this.requestData.info.name) {
                this.$snotify.error('Navn skal udfyldes');
                return;
            }

            try {
                this.loading = true;
                const payload = await PreparationService.create(this.requestData);

                this.$snotify.success(`${this.info.name} er oprettet`);
                this.loading = false;
                this.$emit('created', payload);
            } catch (error) {
                this.loading = false;
            }
        },
    },
    async created() {
        try {
            await this.loadGlobalNotes();
            await this.loadRouteOfAdministration();
            await this.loadSubstances();

            this.routeOfAdministrations = this.getAllRouteOfAdministration.map(route => ({ ...route, selected: false }));

            this.initGlobalNotes();

            // merge default attributes
            if (this.defaultItem !== undefined) {
                if (this.defaultItem.name) {
                    this.info.name = this.defaultItem.name;
                }
                if (this.defaultItem.productNumbers) {
                    this.productNumbers = this.defaultItem.productNumbers.map(item => ({
                        productNumber: item.value,
                    }));
                }
                if (this.defaultItem.routeOfAdministrations) {
                    this.defaultItem.routeOfAdministrations.forEach((item) => {
                        const findRoute = this.routeOfAdministrations.find(route => route.id === item.referenceID);
                        if (findRoute) {
                            this.$set(findRoute, 'selected', true);
                        }
                    });
                }
                if (this.defaultItem.substances) {
                    const substances = this.activeSubstancesList.filter(activeSubs => this.defaultItem.substances.some(item => item.referenceID === activeSubs.id));
                    this.selectedSubstances = [...this.selectedSubstances, ...substances];
                    this.refreshSelectedSubstances();
                }
            }
        } catch (error) {
            //
        }
    },
    watch: {
        'info.publishDate': function temp() {
            this.initGlobalNotes();
            this.refreshSelectedSubstances();
        },
    },
};
</script>
